import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  DefaultPrivacy,
  GetDefaultPrivacyStatusResponse,
  SetDefaultPrivacyStatusResponse,
  getDefaultPrivacyStatus as universalGetDefaultPrivacyStatus,
  setDefaultPrivacyStatus as universalSetDefaultPrivacyStatus,
} from './members-v1-default-privacy-default-privacy.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/members' };

export function getDefaultPrivacyStatus(
  httpClient: HttpClient
): GetDefaultPrivacyStatusSignature {
  return () =>
    universalGetDefaultPrivacyStatus(
      // @ts-ignore
      { httpClient }
    );
}

interface GetDefaultPrivacyStatusSignature {
  /**
   * Retrieves the default privacy status of a site.
   */
  (): Promise<
    NonNullablePaths<
      GetDefaultPrivacyStatusResponse,
      `defaultPrivacy.defaultPrivacy`,
      1
    >
  >;
}

export function setDefaultPrivacyStatus(
  httpClient: HttpClient
): SetDefaultPrivacyStatusSignature {
  return (defaultPrivacy: NonNullablePaths<DefaultPrivacy, `revision`, 0>) =>
    universalSetDefaultPrivacyStatus(
      defaultPrivacy,
      // @ts-ignore
      { httpClient }
    );
}

interface SetDefaultPrivacyStatusSignature {
  /**
   * Sets the default privacy status of a site.
   * @param - Default privacy settings to set.
   */
  (defaultPrivacy: NonNullablePaths<DefaultPrivacy, `revision`, 0>): Promise<
    NonNullablePaths<
      SetDefaultPrivacyStatusResponse,
      `defaultPrivacy.defaultPrivacy`,
      1
    >
  >;
}

export {
  DefaultPrivacy,
  GetDefaultPrivacyStatusRequest,
  GetDefaultPrivacyStatusResponse,
  Privacy,
  SetDefaultPrivacyStatusRequest,
  SetDefaultPrivacyStatusResponse,
} from './members-v1-default-privacy-default-privacy.universal.js';
